module.exports = __webpack_public_path__ + "img/logo-lite.6077d6e.svg";